import { useCallback } from 'react';

const useGTM = () => {
  const pushToDataLayer = useCallback((event) => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push(event);
      console.log('GTM Event pushed:', event);
    }
  }, []);

  const trackPaqueteView = useCallback((paquete) => {
    pushToDataLayer({
      event: 'paquete_view',
      paquete_id: paquete.id,
      paquete_titulo: paquete.titulo,
      paquete_destino: paquete.destino,
      paquete_precio: paquete.precio,
      paquete_categoria: paquete.categoria,
      timestamp: new Date().toISOString()
    });
  }, [pushToDataLayer]);

  const trackSearch = useCallback((searchParams) => {
    pushToDataLayer({
      event: 'search_paquetes',
      search_destino: searchParams.destino,
      search_transporte: searchParams.transporte,
      search_pasajeros: searchParams.pasajeros,
      search_fecha: searchParams.fecha,
      timestamp: new Date().toISOString()
    });
  }, [pushToDataLayer]);

  const trackFilterApply = useCallback((filters) => {
    pushToDataLayer({
      event: 'filter_applied',
      filter_tipo: filters.tipo,
      filter_precio_min: filters.precioMin,
      filter_precio_max: filters.precioMax,
      filter_duracion: filters.duracion,
      timestamp: new Date().toISOString()
    });
  }, [pushToDataLayer]);

  return {
    pushToDataLayer,
    trackPaqueteView,
    trackSearch,
    trackFilterApply
  };
};

export default useGTM;